import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "20",
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.15047 20C6.34747 20 6.87847 19.174 8.37047 19.174C9.88747 19.174 10.2205 19.975 11.5535 19.975C12.8605 19.975 13.7365 18.728 14.5625 17.508C15.4875 16.109 15.8705 14.736 15.8955 14.673C15.8085 14.647 13.3045 13.592 13.3045 10.629C13.3045 8.061 15.2785 6.904 15.3895 6.815C14.0815 4.882 12.0965 4.832 11.5535 4.832C10.0845 4.832 8.88847 5.747 8.13647 5.747C7.32147 5.747 6.24847 4.882 4.97847 4.882C2.56047 4.882 0.105469 6.942 0.105469 10.833C0.105469 13.248 1.01847 15.804 2.14147 17.457C3.10347 18.856 3.94247 20 5.15047 20ZM8.23547 4.616C9.11047 4.616 10.2085 4.005 10.8625 3.192C11.4545 2.454 11.8855 1.424 11.8855 0.394C11.8855 0.255 11.8745 0.115 11.8485 0C10.8745 0.038 9.70247 0.674 8.99947 1.525C8.44447 2.174 7.93847 3.192 7.93847 4.234C7.93847 4.386 7.96347 4.539 7.97647 4.589C8.03747 4.603 8.13647 4.616 8.23547 4.616Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}